<script>
import FeedbackBrandsBadge from "@js/components/Sections/Feedbacks/Components/FeedbackBrandsBadge.vue";

export default {
    name: "FeedbackPlatforms",
    components: {FeedbackBrandsBadge}
}
</script>

<template>
    <div class="pt-20">
        <div class="container">
            <div class="mb-10">
                <h2 class="text-xl md:text-3xl font-semibold text-start md:text-center">
                    Мы стараемся чтобы клиенты всегда были довольны!
                </h2>
            </div>
        </div>
        <FeedbackBrandsBadge/>
    </div>
</template>

<style scoped lang="scss">

</style>
